<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:modelColumnDefs="modelColumnDefs"
		></pui-datatable>
	</div>
</template>

<script>

export default {
	name: 'mpollutionalertsauthorities-grid',
	components: {
	},
	data() {
		return {
			modelName: 'mpollutionalertsauthorities',
			modelColumnDefs: {
			}
		}
	}
}
</script>
